import React from 'react';
import PageMeta from '../components/common/PageMeta';
import ContactsForm from '../components/contact/ContactsForm';
import ReviewTwo from '../components/tabs/ReviewTabTwo';
import FooterSocial from '../layout/Footer/FooterSocial';
import Navbar_Aiims from '../layout/Header/Navbar_Aiims';
import Layout from '../layout/Layout';
import SoftwareCompanyFeedback from '../components/softwareCompanyHome/SoftwareCompanyFeedback'

const GetQuoteAiims = () => {
  return (
    <Layout>
      <PageMeta title='Request for Deomo - Software &amp; IT Solutions HTML Template' />
      <Navbar_Aiims navDark posAbsolute />
      <section
        className='sign-up-in-section bg-dark ptb-120'
        style={{
          background:
            "url('assets/img/page-header-bg.svg')no-repeat bottom right",
        }}
      >
        <div className='container'>
          <div className='row align-items-center justify-content-between'>
            <ContactsForm />
            <ReviewTwo reqPage/>
          </div>
        </div>
      </section>
      <SoftwareCompanyFeedback 
       ifForQuote = {true}/>
      <FooterSocial/>
    </Layout>
  );
};

export default GetQuoteAiims;
